const CouponCard = ({ amount, coupons, onOpenForm }) => (
    <div className="card-text d-flex flex-column">
        <div className="d-flex flex-column align-items-center text-center position-relative">
            <div className="position-relative" style={{ display: 'inline-block' }}>
                <img
                    src="https://storingdocuments.s3.ap-south-1.amazonaws.com/coupon.jfif"
                    alt="Free consultation coupon"
                    className="img-fluid"
                    style={{ maxWidth: '250px', borderRadius: '8px' }}
                />
                <div
                    style={{
                        position: 'absolute', top: '58%', left: '49%', transform: 'translate(-50%, -10px)',
                        fontSize: '12px', color: '#0E3984', fontWeight: 'bold', textAlign: 'center', width: '100%',
                    }}
                >
                    Worth of RS. {amount}/-
                </div>
                <div
                    style={{
                        position: 'absolute', bottom: '13px', left: '33px', width: '85%', display: 'flex',
                        justifyContent: 'center', alignItems: 'center',
                    }}
                >
                    <span style={{ color: '#0E3984', fontSize: '12px', fontWeight: 'bold' }}>Valid for only Family Members.</span>
                </div>
            </div>
        </div>

        <div className="mt-2">
            {coupons > 0 ? (
                <>You have a maximum of <strong className="text-danger">{coupons}</strong> coupons.</>
            ) : (
                <span className="text-muted">You have already used all your coupons.</span>
            )}
        </div>

        {coupons > 0 ? (
            <button type="button" className="btn btn-success d-flex align-items-center justify-content-center mt-2" onClick={() => onOpenForm('consultation')}>
                <i className="bi bi-ticket-detailed me-2"></i>Avail Coupon
            </button>
        ) : (
            <a href="tel:7032107108" className="btn btn-warning d-flex align-items-center justify-content-center mt-2">
                <i className="bi bi-telephone me-2"></i>Request
            </a>
        )}
    </div>
);

const StandardServiceCard = ({ service, onOpenForm }) => {
    const isLab = service.PoliciesType === 'Lab Investigation';

    return (
        <>
            <p className="card-text">
                {service.DiscountPercentage > 0
                    ? `Enjoy a discount of ${service.DiscountPercentage}% on this service.`
                    : 'No discounts available for this service.'}
            </p>
            <div className="w-100 mt-2">
                <button type="button" className="btn btn-warning w-100" onClick={() => onOpenForm(isLab ? 'lab' : 'other')}>
                    Book Now →
                </button>
            </div>
        </>
    );
};

const HospitalServicesList = ({
    amount,
    dependentCoupons,
    formData,
    hospitalServices,
    memberCoupons,
    memberId,
    onOpenForm,
    selectedMemberType,
    servicesLoading,
}) => {
    const coupons = selectedMemberType === 'member'
        ? memberCoupons[memberId]
        : dependentCoupons[formData.MemberDependentId];

    return (
        <div className="container mt-4">
            <h5 className="text-center">Available Services</h5>
            {servicesLoading ? (
                <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>
                </div>
            ) : hospitalServices.length > 0 ? (
                hospitalServices.map((service) => (
                    <div key={service.HospitalPoliciesProvisionId || service.HospitalPoliciesId || service.PoliciesType} className="card my-3 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title">{service.PoliciesType}</h5>
                            {service.IsActive ? (
                                service.PoliciesType === 'Free Consultation'
                                    ? <CouponCard amount={amount} coupons={coupons} onOpenForm={onOpenForm} />
                                    : <StandardServiceCard service={service} onOpenForm={onOpenForm} />
                            ) : (
                                <p className="text-muted">This service is currently unavailable.</p>
                            )}
                        </div>
                    </div>
                ))
            ) : (
                <p className="text-muted text-center">No services available for this hospital.</p>
            )}
        </div>
    );
};

export default HospitalServicesList;
